import cookie from 'cookie';
import Gateway from './Gateway.js';

export default class GaCookie {
  constructor() {
    this.cookie = cookie.parse(Gateway.window.document.cookie).__utmz;
  }

  isEmpty() {
    return !this.cookie || typeof(this.cookie) !== 'string';
  }

  get campaign() {
    return this._get('utmcid');
  }

  get source() {
    return this._get('utmcsr');
  }

  get medium() {
    return this._get('utmcmd');
  }

  get term() {
    return this._get('utmctr');
  }

  get content() {
    return this._get('utmcct');
  }

  _get(name) {
    const matches = !this.isEmpty() ? this.cookie.match(`${name}=([^|]*)`) : [];
    return (matches && matches[1]) ? matches[1] : null;
  }
}
